import request from '../config/axiosConfig';
import { GET_LIST_CURRICULUMS, GET_CURRICULUM_INFO, CREATE_CURRICULUM, UPDATE_CURRICULUM, DELETE_CURRICULUM } from '../constants/curriculumApiEndPoint';

export const getCurriculums = async (params) => {
    return (await request({
      url: GET_LIST_CURRICULUMS,
      method: 'GET',
      params,
    }))?.data;
  };
  
export const getCurriculumInfo = async (id) => {
    return (await request({
      url: GET_CURRICULUM_INFO,
      method: 'GET',
      params: { id },
    }))?.data;
};

export const createCurriculum = async (data) => {
    return (await request({
      url: CREATE_CURRICULUM,
      method: 'POST',
      data,
    }))?.data;
};

export const updateCurriculum = async (id, data) => {
    return (await request({
      url: UPDATE_CURRICULUM,
      method: 'POST',
      params: { id },
      data,
    }))?.data;
};

export const deleteCurriculum = async (id) => {
    return (await request({
      url: DELETE_CURRICULUM,
      method: 'DELETE',
      params: { id },
    }))?.data;
};
